import { ONLINE_STATUS } from "@/react/components/constants";
import type { CommunityMember } from "@/react/types";
import type { ChatRoomParticipant } from "@/react/types/Chat/ChatRoomParticipant";

export const shouldShowMessageOption = (
  currentCommunityMember: CommunityMember,
  member: CommunityMember,
) => {
  const isCurrentCommunityMemberProfile =
    currentCommunityMember?.id == member.id;
  const isCommunityMemberDeactivated = member.is_deleted;
  return (
    !isCommunityMemberDeactivated &&
    !isCurrentCommunityMemberProfile &&
    currentCommunityMember?.messaging_enabled &&
    member.messaging_enabled
  );
};

export const shouldShowRemoveOption = (
  currentCommunityMember: CommunityMember,
  member: CommunityMember,
) => {
  const isCurrentCommunityMemberProfile =
    currentCommunityMember?.id == member.id;
  return !isCurrentCommunityMemberProfile && currentCommunityMember?.is_admin;
};

export const sortParticipants = (participants: ChatRoomParticipant[] = []) => {
  const moderators: ChatRoomParticipant[] = [];
  const nonModerators: ChatRoomParticipant[] = [];
  participants.forEach(participant => {
    if (participant.admin) {
      moderators.push(participant);
    } else {
      nonModerators.push(participant);
    }
  });
  return [...moderators, ...nonModerators];
};

export const mapParticipantsPerStatus = (
  participants: ChatRoomParticipant[],
) => {
  const onlineParticipants: ChatRoomParticipant[] = [];
  const offlineParticipants: ChatRoomParticipant[] = [];
  const idleParticipants: ChatRoomParticipant[] = [];

  participants
    .filter(({ deleted_at }) => !deleted_at)
    .forEach(participant => {
      if (participant.status === ONLINE_STATUS["online"]) {
        onlineParticipants.push(participant);
      } else if (participant.status === ONLINE_STATUS["idle"]) {
        idleParticipants.push(participant);
      } else {
        offlineParticipants.push(participant);
      }
    });

  return {
    onlineParticipants: [...onlineParticipants, ...idleParticipants],
    offlineParticipants,
  };
};
